import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { CreateVideoPageWrapper } from "./-VideoPage"

const createVideoSearchSchema = z.object({
  imageUrl: z.string().optional(),
  model: z.string().optional(),
  preset: z.string().optional(),
  prompt: z.string().optional(),
  duration: z.string().optional(),
  aspect_ratio: z.string().optional(),
  negative_prompt: z.string().optional(),
})

export const Route = createFileRoute("/create/video")({
  validateSearch: createVideoSearchSchema,
  component: CreateVideoPageWrapper,
})
